import {
    BULK_ASSIGN_ALERT_TYPES_OPEN_MODAL,
    BULK_ASSIGN_ALERT_TYPES_REQUEST,
    BULK_ASSIGN_ALERT_TYPES_RESULT,
} from 'Redux/actionTypes';

export const bulkAssignAlertTypesOpenModal = (open, data) => ({
    type: BULK_ASSIGN_ALERT_TYPES_OPEN_MODAL,
    payload: { open, data }
})

export const bulkAssignAlertTypesRequest = (data) => ({
    type: BULK_ASSIGN_ALERT_TYPES_REQUEST,
    payload: { data }
})

export const bulkAssignAlertTypesResult = (data) => ({
    type: BULK_ASSIGN_ALERT_TYPES_RESULT,
    payload: { data }
})

